module.exports = __webpack_public_path__ + "img/nofolderselected.eab7d20d.svg";